"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Point = _interopRequireDefault(require("../geometry/Point"));

var Translation = /*#__PURE__*/function () {
  function Translation() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    (0, _classCallCheck2["default"])(this, Translation);
    (0, _defineProperty2["default"])(this, "_point", new _Point["default"]());
    this._point = new _Point["default"](x, y);
  }

  (0, _createClass2["default"])(Translation, [{
    key: "copy",
    value: function copy() {
      return new Translation(this.x, this.y);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        x: this.x,
        y: this.y
      };
    }
    /**
     * Checks if object is an instance of Translation
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "x",
    get: function get() {
      return this._point.x;
    },
    set: function set(value) {
      this._point.x = value;
    }
  }, {
    key: "y",
    get: function get() {
      return this._point.y;
    },
    set: function set(value) {
      this._point.y = value;
    }
  }], [{
    key: "isTranslation",
    value: function isTranslation(inputObject) {
      return inputObject instanceof Translation;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if (!json) {
        return null;
      }

      return new Translation(json.x, json.y);
    }
  }]);
  return Translation;
}();

exports["default"] = Translation;